export default __webpack_public_path__ + "static/media/search.a7af9cd4.png";